import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { Text as TextWrap } from '../ResultTable.styles';

export const Text = styled(TextWrap)`
	color: black;
`;

export const CellText = styled.div`
	color: ${colors.grey5};
	text-align: center;
	font-size: 13px;
	letter-spacing: 0.3px;
	width: 100%;
`;

export const InputText = styled(CellText)`
	display: flex;
	justify-content: center;
	color: ${colors.grey5};
	text-align: right;
	padding-right: 6px;
`;

export const EditInput = styled.input`
	all: unset;
	color: ${colors.grey8};
	font-weight: 500;
	font-size: 13px;
	width: 100%;
`;
